import { Avatar, Badge, Box, Chip, Drawer, Grid, Stack, Tab, Tabs, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { IMG_BASE_URL } from "src/config/constants";
import MerchantInfoDrawer from "./MerchantInfoDrawer";

export default function MerchantInfo({ name, logo, mobile, mid, enablePreview = true }) {
  const [show, setShow] = useState(false);

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={{
          display: 'inline-flex',
          cursor: enablePreview ? "pointer" : "default",
        }}
        onClick={() => {
          if (!enablePreview) return;
          setShow(true);
        }}
      >
        <Badge
          color="primary"
          badgeContent="商"
          // anchorOrigin={{
          //   vertical: "bottom",
          //   horizontal: "right",
          // }}
        >
          <Avatar alt={name} src={`${(logo || '').startsWith('http') ? '' : IMG_BASE_URL}${logo}?w=60`} />
        </Badge>

        <Stack>
          <Stack direction="row">
            <Typography variant="subtitle2" noWrap>
              {name}
            </Typography>
            {/* <Chip label="商" size="small"></Chip> */}
          </Stack>
          <Typography variant="subtitle2" noWrap>
            {mid}
          </Typography>
        </Stack>
      </Stack>
      {show && <MerchantInfoDrawer mid={mid} logo={logo} name={name} open onClose={() => setShow(false)} />}
    </>
  );
}
